const funcImgsWH = () => {

  //画像読み込みをPromiseで扱う関数(変更なし)
  const myFunc = function (src) {
    return new Promise(function (resolve, reject) {
      const image = new Image();
      image.src = src;

      image.onload = function () {
        resolve(image);
      }

      image.onerror = function (error) {
        reject(error);
      }
    });
  }

  //候補を順番に試す関数
  const tryLoad = (candidates, index, img) => {
    if (index >= candidates.length) return;

    myFunc(candidates[index])
      .then(function (res) {
        img.setAttribute('width', res.width);
        img.setAttribute('height', res.height);
      })
      .catch(function () {
        tryLoad(candidates, index + 1, img);
      });
  }

  const imgs = document.getElementsByTagName('img');

  for (const img of imgs) {

    let candidates = [];
    const picture = img.closest('picture');

    if (picture) {
      //picture内のsource要素を順に走査
      const sources = picture.querySelectorAll('source');

      sources.forEach((source) => {
        const media = source.getAttribute('media');

        //media指定が無い、またはmatchMediaで現在マッチする場合のみ候補に追加
        if (!media || window.matchMedia(media).matches) {
          const srcset = source.getAttribute('srcset');
          if (srcset) {
            candidates.push(srcset);
          }
        }
      });
    }

    //最終フォールバックとしてimg自身のsrcを追加
    const src = img.getAttribute('src');
    if (src) {
      candidates.push(src);
    }

    tryLoad(candidates, 0, img);
  }

}


if (document.querySelector("body#pageTop") !== null) {
  funcImgsWH()
}


export default funcImgsWH;